<div class="chip-list-wrapper">
  <mat-chip-listbox #chipList>
    @for (select of selectData; track select.item) {
      <mat-chip-option (click)="removeChip(select)">
        {{ select.item[lableBinding] }}
      </mat-chip-option>
    }
  </mat-chip-listbox>
</div>

<mat-form-field class="w-full">
  <input
    matInput
    type="text"
    placeholder="{{ placeholder | transloco }}"
    [matAutocomplete]="auto"
    [formControl]="searchFormControl"
  />
  @if (loading$ | async) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="20"
    ></mat-progress-spinner>
  }
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
  @for (data of data$ | async; track data) {
    <mat-option>
      <div (click)="optionClicked($event, data)">
        <mat-checkbox
          [checked]="data.selected"
          (change)="toggleSelection(data)"
          (click)="$event.stopPropagation()"
        >
          {{ data.item[lableBinding] }}
        </mat-checkbox>
      </div>
    </mat-option>
  }
</mat-autocomplete>
